/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import {
  TECH_COST,
  STAFFING_COST,
  STAFFING_COST_UPDATE,
} from '../resources/endPoint';

export const getSoftwareData = (id, page, limit) => {
  return {
    url: `${TECH_COST}?dealId=${id}&type=SOFTWARE&page=${page}&limit=${limit}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

export const getHardwareData = (id = 18, page = 1, limit = 10) => {
  return {
    url: `${TECH_COST}?dealId=${id}&type=HARDWARE&page=${page}&limit=${limit}`,
    method: 'get',
    headers: { 'content-type': 'application/json', token: 'token' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DEAL_TRANSITION_MS,
  };
};

//Delete API SW/HW

export const deleteSoftwareHardware = (id = 18) => {
    return {
      url: `${TECH_COST}?id=${id}`,
      method: 'delete',
      headers: { 'content-type': 'application/json', token: 'token' },
      authRequired: false,
      csrfToken: true,
      service: serviceName.DEAL_TRANSITION_MS,
    };
  };

  export const saveSoftwareHardware = (data,deal_id) => {
    return {
      url: `${TECH_COST}/deal/${deal_id}`,
      method: 'post',
      headers: { 'content-type': 'application/json', token: 'token' },
      authRequired: false,
      csrfToken: true,
      service: serviceName.DEAL_TRANSITION_MS,
      payload:data
    };
  };

  export const editSoftwareHardware = (data,deal_id) => {
    return {
      url: `${TECH_COST}/id/${deal_id}`,
      method: 'put',
      headers: { 'content-type': 'application/json', token: 'token' },
      authRequired: false,
      csrfToken: true,
      service: serviceName.DEAL_TRANSITION_MS,
      payload:data
    };
  };

  export const saveDealCloudCost = (data, dealId) => {
    return {
      url: `${TECH_COST}/deal/${dealId}`,
      method: 'post',
      headers: { 'content-type': 'application/json', token: 'token' },
      authRequired: false,
      csrfToken: true,
      payload: data,
      service: serviceName.DEAL_TRANSITION_MS,
    };
  };
  export const getDealCloudCost = (dealId) => {
    return {
      url: `${TECH_COST}?dealId=${dealId}&type=CLOUD&page=1&limit=1000`,
      method: 'get',
      headers: { 'content-type': 'application/json', token: 'token' },
      authRequired: false,
      csrfToken: true,
      service: serviceName.DEAL_TRANSITION_MS,
    };
  };
  
  export const deleteDealCloudCost = (id) => {
    return {
      url: `${TECH_COST}?id=${id}`,
      method: 'delete',
      headers: { 'content-type': 'application/json' },
      authRequired: false,
      csrfToken: true,
      service: serviceName.DEAL_TRANSITION_MS,
    };
  };
  
  export const editDealCloudCost = (data, id) => {
    return {
      url: `${TECH_COST}/id/${id}`,
      method: 'put',
      headers: { 'content-type': 'application/json', token: 'token' },
      authRequired: false,
      csrfToken: true,
      payload: data,
      service: serviceName.DEAL_TRANSITION_MS,
    };
  };

  export const staffingCostList = (data, page, limit, dealId) => {
    const url = `${STAFFING_COST}/${dealId}/?page=${page}&limit=${limit}`;
    return {
      url: url,
      method: 'get',
      headers: { 'content-type': 'application/json' },
      authRequired: false,
      csrfToken: true,
      payload: data,
      service: serviceName.DEAL_TRANSITION_MS,
    };
  };
  
  export const updateStaffingCost = (dealId, data) => {
    return {
      url: `${STAFFING_COST_UPDATE}/${dealId}/`,
      method: 'put',
      headers: { 'content-type': 'application/json', token: 'token' },
      authRequired: false,
      csrfToken: true,
      service: serviceName.DEAL_TRANSITION_MS,
      payload: data,
    };
  };
